import React, { lazy, Suspense, useEffect } from "react";
import { Spin } from "antd";

import { BrowserRouter, Routes, Route, Navigate, Outlet, useRoutes } from "react-router-dom";
import { getUser } from "Util/index";

import { connect } from "react-redux";
import { getSocket, syncSocketWithAuth } from "Util/socket";
import Login from "components/Login";
import Modules from "components/home/index";
import Loading from "components/Loading";
import CustomerRouteBoundary from "components/portal/RouteBoundary";
import * as PolicyProvider from "components/Policy/Ctx";
import { PermisosProvider } from "components/Permisos/PermisosContext";
// T3/100A04: protección de pantallas por permiso (REACT_APP_SEC_ROUTE_GUARD=true).
import RouteGuard from "components/Permisos/RouteGuard";
import { SEC_ROUTE_GUARD } from "config/featureFlags";
// T3/100A06: protección por pantalla.
import AppErrorBoundary from "components/common/AppErrorBoundary";
import {
  pathCustomers,
  pathSubsidiary,
  pathCustomerUsers,
  pathConfig,
  pathMaintenancePlan,
  pathRoadmap,
  pathSchedulePlans,
  pathOrder,
  pathMyOrders,
  pathMyEquipments,
  pathMonitoringUser,
  pathMaterial,
  pathOrderMaterial,
  pathTools,
  pathWarehouse,
  pathToolOrder,
  pathReportMaintenances,
  pathConfigSite,
  pathFeedback,
  pathMonitoringLocation,
  pathProjects,
  pathDesign,
  pathPrintVisit,
  pathEditVisit,
  pathReportMinorBox,
  pathMyMaintenances,
  pathInventory,
  rutaCotizaciones,
  rutaUnidades,
  rutaCotizacionEstado,
  pathProjectsActivities,
  rutaReporteCausaRaiz,
  rutaReporteSlaCotizacion,
  rutaReporteSlaCorrectivos,
  rutaReporteEntregaCorrectivos,
  rutaReporteSlaEmergencias,
  rutaReportePendingReviews,
  rutaCotizacionesDashboard,
  rutaCotizacionesUN,
  pathSiigoDashboard,
  pathCrm,
  pathContracts,
  pathDashboardEjecutivo,
  pathBilling,
  pathBovedas,
  pathCostParameters,
  pathActivosTi,
  pathSolicitudAdmin,
  pathSolicitudAltaUsuario,
  pathControlCambios,
  pathMisReportes,
  pathOutlookConnect,
  pathMiFirma,
  // T2/100A140
  pathCalendarioLaboral,
  // T2/100A141, A142
  pathConfigSla,
  pathConfigKpis,
  pathPortal,
  pathServicios,
  pathSolicitudes,
  pathSolicitudesMisCasos,
} from "Path";
import FeedbackButton from "components/ControlCambios/FeedbackButton";
import ArchivoMantenimientos from "./Archivos";
import RefrigranteListado from "./Refrigerante/Listado";
import Apk from "./Apk";
// T2/100A01: Rutas del módulo nuevo Gestion Compras (Pricebook). Se agregan al
// final de `pages`; ninguna ruta existente cambia.
import { gestionComprasRoutes } from "features/gestion-compras/routes";
// T2/100A96: redirecciones del Compras original al módulo nuevo.
import { legacyComprasRedirects } from "features/gestion-compras/routes";

const MaterialList = lazy(() => import("components/materials"))
const ConfigurarHorasExtras = lazy(() => import("components/ConfigurarNomina"))
// T2/100A140: calendario laboral.
const CalendarioLaboral = lazy(() => import("features/configuracion/calendario-laboral/pages/WorkCalendarPage"))
// T2/100A141, A142: SLA y Configuración de KPI.
const ConfigSla = lazy(() => import("features/configuracion/sla/pages/SlaPage"))
const ConfigKpis = lazy(() => import("features/configuracion/kpis/pages/KpiConfigPage"))

const MaterialGroupSave = lazy(() => import("components/MaterialGroup/Save"))
const MaterialGroupList = lazy(() => import("components/MaterialGroup/List"))
const HorasExtras = React.lazy(() => import("components/HorasExtras"))
const HistorialEmpleadoHorasExtras = React.lazy(() => import("components/HorasExtras/HistorialEmpleado"))
const HistorialClienteHorasExtras = React.lazy(() => import("components/HorasExtras/HistorialCliente"))
const CustomerOrders=React.lazy(() => import("components/customerOrder"))
const CotizacionEstados=React.lazy(() => import("components/cotizacionEstados/Listado"))
const Unidades=React.lazy(() => import("components/unidadMedida/Listado"))
const CotizacionListado=React.lazy(() => import("components/Cotizacion/Listado"))
const InventarioListado=React.lazy(() => import("components/inventory/list"))
const MantenimientoListado= React.lazy(() => import("components/maintenance/list"))
const ProyectoEditarVisita=React.lazy(() => import("components/projectVisit/edit"))
const ProyectoImprimirVisita=React.lazy(() => import("components/projectVisit/print"))
const ProyectoListadoDisenos= React.lazy(() => import("components/projectDesign/List"))
const ProyectoListado=React.lazy(() => import("components/project/List"))
const ProyectoActividades=React.lazy(() => import("components/project/Activities/List"))
const FeedBack=React.lazy(() => import("components/feedback"))
const ConfigSite=React.lazy(() => import("components/configSite"))
const CajaMenor=React.lazy(() => import("components/report/minorBox"))
const Mantenimientos=React.lazy(() => import("components/report/maintenances"))
const HerramientasOrdenes=React.lazy(() => import("components/toolOrder/list"))
const Bodegas=React.lazy(() => import("components/warehouse/list"))
const Herramientas=React.lazy(() => import("components/tools/list"))
const MaterialOrdenes=React.lazy(() => import("components/materialOrder"))
const ClienteEquipos=React.lazy(() => import("components/customerEquipments"))
const MonitoreoUbuicacion=React.lazy(() => import("components/userLocations"))
const PlanesMantenimiento=React.lazy(() => import("components/maintenancePlan/List"))
const UsuarioMonitoreo=React.lazy(() => import("components/userMonitoring"))
const HojasRutas=React.lazy(() => import("components/Roadmap/List"))
const MisOrdenes=React.lazy(() => import("components/Order/My"))
const Ordenes=React.lazy(() => import("components/Order/List"))
const OrdenesCalendario=React.lazy(() => import("components/OrderCalendar/"))
const Programacion=React.lazy(() => import("components/schedulePlans/List"))
const Usuarios= React.lazy(() => import("components/user/List"))
const UsuariosDashboard= React.lazy(() => import("components/user/DashboardRoute"))
const CategoriasUsuarios=React.lazy(() => import("components/categoryUser/List"))
const CargosPermisos=React.lazy(() => import("components/Cargos/CargosPage"))
const PuestosDeTrabajos=React.lazy(() => import("components/jobPosition/List"))
const TipoOrdenes=React.lazy(() => import("components/Order-type/List"))
const TipoEquipos=React.lazy(() => import("components/EquipmentType/List"))
const EquipoSucursal=React.lazy(() => import("components/subsidiaryEquipment/List"))
const SpendPlanDetalle=React.lazy(() =>
      import("components/Cotizacion/Spend")
    )
const SpendPlan=React.lazy(() =>
      import("components/SpendPlan")
    )
const Clienteusuarios=React.lazy(() => import("components/customerUser/List"))

const SubsidiaryList = React.lazy(() => import("components/subsidiary/List"))
const CustomerEquipments = React.lazy(() => import("components/customer/Equipments"))
const CustomerList = React.lazy(() => import("components/customer/List"))
const CausaRaizListado = React.lazy(() => import("components/CausaRaiz/Listado"))
const CausaRaizReporte = React.lazy(() => import("components/CausaRaiz/Reporte"))
const SlaCotizacionReporte = React.lazy(() => import("components/SlaCotizacion/Reporte"))
const EntregaCorrectivosReporte = React.lazy(() => import("components/CorrectivosEntrega/Reporte"))
const PendingReviewsReporte = React.lazy(() => import("components/TransicionesPendientes/Reporte"))
const EmergenciaSlaReporte = React.lazy(() => import("components/EmergenciaSla/Reporte"))
const CotizacionDashboard = React.lazy(() => import("components/Cotizacion/Dashboard"))
const CotizacionUnidadNegocio = React.lazy(() =>
  import("components/Cotizacion/UnidadNegocio/Listado")
)
const CarbonFootprint = React.lazy(() => import("components/CarbonFootprint"))
const CotizacionPlantillas=React.lazy(() => import("components/Cotizacion/plantillas"))
const SiigoDashboard=React.lazy(() => import("components/Siigo/Dashboard"))
const CrmDashboard=React.lazy(() => import("components/CRM"))
const Competidores=React.lazy(() => import("components/CRM/Competidores"))
const ContractsDashboard=React.lazy(() => import("components/Contracts"))
const DashboardEjecutivo=React.lazy(() => import("components/DashboardEjecutivo"))
const BillingModule=React.lazy(() => import("components/Billing"))
const CostParameters=React.lazy(() => import("components/Administracion/CostParameters"))
const BovedasList=React.lazy(() => import("components/bovedas/List"))
const BovedasCredenciales=React.lazy(() => import("components/bovedas/Credenciales"))
const ActivosTiList=React.lazy(() => import("components/activosTi/List"))
const ActivosTiFiles=React.lazy(() => import("components/activosTi/Files"))
const SolicitudAdminList=React.lazy(() => import("components/solicitudAdmin/List"))
const SolicitudAltaUsuarioList=React.lazy(() => import("components/solicitud-alta-usuario/List"))
const TurnosDisponibilidad = lazy(() => import("components/TurnosDisponibilidad"))
const ConfiguracionNotificaciones=React.lazy(() => import("components/Notifications/ConfiguracionNotificaciones"))
const ControlCambiosAdmin = React.lazy(() => import('components/ControlCambios'))
const MisReportes = React.lazy(() => import('components/ControlCambios/MisReportes'))
const ConectarOutlook = React.lazy(() => import('components/Outlook/ConectarOutlook'))
const MiFirma = React.lazy(() => import('components/user/MiFirma'))

const PortalHome = React.lazy(() => import('components/portal/Home'))
const PortalSedeDashboard = React.lazy(() => import('components/portal/SedeDashboard'))
const PortalSolicitudes = React.lazy(() => import('components/portal/Solicitudes'))
const PortalCotizaciones = React.lazy(() => import('components/portal/Cotizaciones'))
const PortalInformes = React.lazy(() => import('components/portal/Informes'))
const ServiciosSolicitudes = React.lazy(() => import('components/Servicios'))
const LegacySolicitudesRedirect = React.lazy(() => import('components/Servicios/LegacySolicitudesRedirect'))
const MisCasosRedirect = React.lazy(() => import('components/Servicios/MisCasosRedirect'))
const ServiciosDashboard = React.lazy(() => import('components/Servicios/Dashboard'))

const pages = [
  {
    path: "/",
    props: { exact: true },
    element: <Modules />,
  },
  {
    path: "/configuracion/refrigerante/listado",
    element: <RefrigranteListado/>,
  },
  {
    path: "/historico-archivos",
    props: { exact: true },
    element: <ArchivoMantenimientos/>,
  },
  {
    path: "/horas-extras",
    props: { exact: true },
    element: <HorasExtras/>,
  },
  {
    path: "/horas-extras/historial",
    props: { exact: true },
    element: <HistorialEmpleadoHorasExtras/>,
  },
  {
    path: "/horas-extras/historial/cliente",
    props: { exact: true },
    element: <HistorialClienteHorasExtras/>,
  },
  {
    path: "/customer/order",
    props: {},
    element: <CustomerOrders/>,
  },
  {
    path: rutaCotizacionEstado,
    element: <CotizacionEstados/>,
  },
  {
    path: rutaUnidades,
    props: { exact: true },
    element: <Unidades/>,
  },
  {
    path: rutaCotizaciones,
    props: { exact: true },
    element: <CotizacionListado/>
  },
  {
    path: pathInventory,
    props: { exact: true },
    element: <InventarioListado/>,
  },
  {
    path: pathMyMaintenances,
    props: { exact: true },
    element:<MantenimientoListado/>,
  },
  {
    path: pathEditVisit,
    props: { exact: true },
    element: <ProyectoEditarVisita/>,
  },
  {
    path: pathPrintVisit,
    props: { exact: true },
    element: <ProyectoImprimirVisita/>,
  },
  {
    path: pathDesign,
    props: { exact: true },
    element:<ProyectoListadoDisenos/>,
  },
  {
    path: pathProjects,
    props: { exact: true },
    element: <ProyectoListado/>,
  },
  {
    path: pathProjectsActivities,
    props: { exact: true },
    element: <ProyectoActividades/>,
  },
  {
    path: pathFeedback,
    props: { exact: true },
    element: <FeedBack/>,
  },
  {
    path: pathConfigSite,
    props: { exact: true },
    element: <ConfigSite/>,
  },
  {
    path: pathReportMinorBox,
    props: { exact: true },
    element: <CajaMenor/>,
  },
  {
    path: pathReportMaintenances,
    props: { exact: true },
    element: <Mantenimientos/>,
  },
  {
    path: pathToolOrder,
    props: { exact: true },
    element: <HerramientasOrdenes/>,
  },
  {
    path: pathWarehouse,
    props: { exact: true },
    element: <Bodegas/>,
  },
  {
    path: pathTools,
    props: { exact: true },
    element: <Herramientas/>,
  },
  {
    path: pathOrderMaterial,
    props: { exact: true },
    element: <MaterialOrdenes/>,
  },
  {
    path: pathMaterial,
    props: { exact: true },
    element: <MaterialList />,
    children: [
      {
        path: "groups",
        element: <MaterialGroupList />,
        children: [
          {
            path: "add",
            element: <MaterialGroupSave />
          },
          {
            path: "edit/:material_group_id",
            element: <MaterialGroupSave />
          }
        ]
      }
    ]
  },
  {
    path: pathMyEquipments,
    props: { exact: true },
    element: <ClienteEquipos/>,
  },
  {
    path: pathMonitoringLocation,
    props: { exact: true },
    element: <MonitoreoUbuicacion/>,
  },
  {
    path: pathMaintenancePlan.list,
    props: { exact: true },
    element: <PlanesMantenimiento/>,
  },
  {
    path: pathMonitoringUser,
    props: { exact: true },
    element: <UsuarioMonitoreo/>,
  },
  {
    path: pathRoadmap.list,
    props: { exact: true },
    element: <HojasRutas/>,
  },
  {
    path: pathMyOrders,
    props: { exact: true },
    element: <MisOrdenes/>,
  },
  {
    path: pathOrder.list,
    props: { exact: true },
    element: <Ordenes/>,
  },
  {
    path: pathOrder.calendar,
    props: { exact: true },
    element: <OrdenesCalendario/>,
  },
  {
    path: pathSchedulePlans,
    props: { exact: true },
    element: <Programacion/>,
  },
  {
    path: pathConfig.user,
    props: { exact: true },
    element:<Usuarios/>,
  },
  {
    path: "/user/dashboard",
    props: { exact: true },
    element: <UsuariosDashboard />,
  },
  {
    path: pathConfig.category_user,
    props: { exact: true },
    element: <CategoriasUsuarios/>,
  },
  {
    path: pathConfig.cargos,
    props: { exact: true },
    element: <CargosPermisos/>,
  },
  {
    path: pathConfig.job_positions,
    props: { exact: true },
    element: <PuestosDeTrabajos/>,
  },
  {
    path: pathConfig.type_orders,
    props: { exact: true },
    element: <TipoOrdenes/>,
  },
  {
    path: pathConfig.type_equipments,
    props: { exact: true },
    element: <TipoEquipos/>,
  },
  {
    path: pathSubsidiary.equipments,
    props: { exact: true },
    element: <EquipoSucursal/>,
  },
  {
    path: pathCustomerUsers.list,
    props: { exact: true },
    element: <Clienteusuarios/>,
  },
  {
    path: pathSubsidiary.list,
    props: { exact: true },
    element: <SubsidiaryList/>,
  },
  {
    path: pathCustomers.equipments,
    props: { exact: true },
    element: <CustomerEquipments/>,
  },
  {
    path: pathCustomers.list,
    props: { exact: true },
    element: <CustomerList/>,
  },
  {
    path: pathConfig.causa_raiz,
    props: { exact: true },
    element: <CausaRaizListado/>,
  },
  {
    path: rutaReporteCausaRaiz,
    props: { exact: true },
    element: <CausaRaizReporte/>
  },
  {
    path: rutaReporteSlaCotizacion,
    props: { exact: true },
    element: <SlaCotizacionReporte/>
  },
  {
    path: rutaReporteSlaCorrectivos,
    props: { exact: true },
    element: <Navigate to={rutaReporteEntregaCorrectivos} replace />
  },
  {
    path: rutaReporteEntregaCorrectivos,
    props: { exact: true },
    element: <EntregaCorrectivosReporte/>
  },
  {
    path: rutaReporteSlaEmergencias,
    props: { exact: true },
    element: <EmergenciaSlaReporte/>
  },
  {
    path: rutaReportePendingReviews,
    props: { exact: true },
    element: <PendingReviewsReporte/>
  },
  {
    path: rutaCotizacionesDashboard,
    props: { exact: true },
    element: <CotizacionDashboard/>,
  },
  {
    path: rutaCotizacionesUN,
    props: { exact: true },
    element: <CotizacionUnidadNegocio/>
  },
  {
    path: "/carbon-footprint",
    props: { exact: true },
    element: <CarbonFootprint/>,
  },
  {
    path: '/spend-plan',
    props: { exact: true },
    element: <SpendPlan/>,
  },
  {
    path: '/spend-plan/:id/detail',
    props: { exact: true },
    element: <SpendPlanDetalle/>,
  }
  ,
  // T2/100A140
  {
    path: pathCalendarioLaboral,
    props: { exact: true },
    element: <CalendarioLaboral/>,
  },
  // T2/100A141
  {
    path: pathConfigSla,
    props: { exact: true },
    element: <ConfigSla/>,
  },
  // T2/100A142
  {
    path: pathConfigKpis,
    props: { exact: true },
    element: <ConfigKpis/>,
  },
  {
    path: '/configuracion/horas-extras',
    props: { exact: true },
    element: <ConfigurarHorasExtras/>,
  },
  {
    path:"/apk",
    element:<Apk/>
  },
  {
    path:"/marker-rates-templates",
    element:<CotizacionPlantillas/>
  },
  {
    path: pathSiigoDashboard,
    element: <SiigoDashboard />,
  },
  {
    path: pathCrm.dashboard,
    element: <CrmDashboard />,
  },
  {
    path: pathCrm.competitors,
    element: <Competidores />,
  },
  {
    path: pathContracts.dashboard,
    element: <ContractsDashboard />,
  },
  {
    path: pathDashboardEjecutivo,
    element: <DashboardEjecutivo />,
  },
  {
    path: pathBilling,
    element: <BillingModule />,
  },
  {
    path: pathCostParameters,
    element: <CostParameters />,
  },
  {
    path: pathBovedas.list,
    element: <BovedasList />,
  },
  {
    path: pathBovedas.detail,
    element: <BovedasCredenciales />,
  },
  {
    path: pathActivosTi.list,
    element: <ActivosTiList />,
  },
  {
    path: pathActivosTi.detail,
    element: <ActivosTiFiles />,
  },
  {
    path: pathSolicitudAdmin.list,
    element: <SolicitudAdminList />,
  },
  {
    path: pathSolicitudAltaUsuario.list,
    element: <SolicitudAltaUsuarioList />,
  },
  {
    path: '/notifications/config',
    element: <ConfiguracionNotificaciones />,
  },
  {
    path: '/configuraciones/notificaciones',
    element: <ConfiguracionNotificaciones />,
  },
  {
    path: '/configuraciones/turnos-disponibilidad',
    element: <TurnosDisponibilidad />,
  },
  {
    path: pathControlCambios,
    element: <ControlCambiosAdmin />,
  },
  {
    path: pathMisReportes,
    element: <MisReportes />,
  },
  {
    path: pathOutlookConnect,
    element: <ConectarOutlook />,
  },
  {
    path: pathMiFirma,
    element: <MiFirma />,
  },
  {
    path: pathPortal.home,
    props: { exact: true },
    element: <PortalHome />,
  },
  {
    path: pathPortal.sede,
    props: { exact: true },
    element: <PortalSedeDashboard />,
  },
  {
    path: pathPortal.solicitudes,
    props: { exact: true },
    element: <PortalSolicitudes />,
  },
  {
    path: pathPortal.cotizaciones,
    props: { exact: true },
    element: <PortalCotizaciones />,
  },
  {
    path: pathPortal.informes,
    props: { exact: true },
    element: <PortalInformes />,
  },
  {
    path: pathSolicitudes,
    props: { exact: true },
    element: <ServiciosSolicitudes />,
  },
  {
    // Old "Mis casos" URL: redirects to /solicitudes (the Mías tab).
    path: pathSolicitudesMisCasos,
    props: { exact: true },
    element: <MisCasosRedirect />,
  },
  {
    // Permanent redirect: stored notifications carry this legacy URL.
    path: pathServicios.solicitudes,
    props: { exact: true },
    element: <LegacySolicitudesRedirect />,
  },
  {
    path: pathServicios.dashboard,
    props: { exact: true },
    element: <ServiciosDashboard />,
  },
  // T2/100A01: Gestion Compras (ver features/gestion-compras/routes.js).
  ...gestionComprasRoutes,
];

// T3/100A04: con la variable, cada pantalla va dentro de RouteGuard; sin ella, igual que antes.
// T3/100A06: además, cada pantalla va dentro de AppErrorBoundary (key = ruta: al cambiar de
// pantalla se reinicia). Si una pantalla falla, las demás siguen funcionando. Antes:
// const guardedPages = SEC_ROUTE_GUARD
//   ? pages.map((page) => ({ ...page, element: <RouteGuard path={page.path}>{page.element}</RouteGuard> }))
//   : pages;
// T2/100A96: las redirecciones van primero (misma ruta: gana la primera). Antes: pages.map(...)
const guardedPages = [...legacyComprasRedirects, ...pages].map((page) => {
  const element = SEC_ROUTE_GUARD ? <RouteGuard path={page.path}>{page.element}</RouteGuard> : page.element;
  return { ...page, element: <AppErrorBoundary key={page.path}>{element}</AppErrorBoundary> };
});

function ApPRoutes() {
  // T3/100A04: antes useRoutes(pages)
  const routes = useRoutes(guardedPages)

  return routes
}

function Entry(props) {
  const { authed, validatingToken } = props;
  //sessionStorage.getItem("redirect")
  let redirect = null;
  redirect = "/";
  /*redirect && redirect != "" && redirect != "/" && redirect != "/login"
      ? redirect
      : "/";*/


  const Home = () => (
    <PermisosProvider>
    <PolicyProvider.Provider>
      <BrowserRouter >
        <CustomerRouteBoundary>
          <Suspense
            fallback={
              <Spin>
                <div style={{ width: "100%", height: "100vh" }}></div>
              </Spin>
            }
          >
            <ApPRoutes />
          </Suspense>
        </CustomerRouteBoundary>
      </BrowserRouter>
      <FeedbackButton />
    </PolicyProvider.Provider>
    </PermisosProvider>
  );

  const LoginState = () => <Login />;

  // The socket exists from the first render (screens subscribe to it on mount)
  // but only connects while the session is authenticated.
  getSocket();

  useEffect(() => {
    const socket = getSocket();
    const onConnect = () => {
      const u = getUser();
      if (u?._id) socket.emit("join", u._id.toString());
    };
    socket.on("connect", onConnect);
    return () => socket.off("connect", onConnect);
  }, []);

  useEffect(() => {
    if (validatingToken) return;
    syncSocketWithAuth(!!authed);
  }, [authed, validatingToken]);

  return (
    <>
      {!authed && !validatingToken ? (
        LoginState()
      ) : !validatingToken ? (
        Home()
      ) : (
        <Loading />
      )}
    </>
  );
}

const mapToState = (state) => {
  return {
    authed: state.User.authed,
    name: state.User.name,
    validatingToken: state.User.validatingToken,
  };
};

export default connect(mapToState)(Entry);
